export default __webpack_public_path__ + "static/media/logor.2c28842e.png";